import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, useT } from '@repo/common';

/**
 * 비즈니스 계정이 개인 전용 기능(Pathfinder, 이력서, Activities, Coupons 등)에
 * 들어왔을 때 보여주는 차단 상태 화면.
 *
 * @param {boolean} inline 마이페이지 탭처럼 다른 레이아웃 안에 들어갈 때 true
 */
const PersonalOnlyBlocked = ({ inline = false }) => {
  const t = useT();
  const navigate = useNavigate();

  return (
    <div
      className={
        inline
          ? 'flex w-full flex-col items-center justify-center py-20 text-center'
          : 'flex min-h-screen w-full flex-col items-center justify-center bg-grayscale-gray01 p-4 text-center tabletH:p-20 tabletH:pt-0'
      }
    >
      <div className='flex flex-col items-center gap-6'>
        <div className='flex max-w-[620px] flex-col items-center gap-2'>
          <h2 className='typo-b18Strong tabletH:typo-h6 text-text-primary'>
            {t('This page is for personal accounts', '개인 계정 전용 페이지예요')}
          </h2>
          <p className='typo-b12 tabletH:typo-b16 text-text-secondary'>
            {t(
              "You're signed in with a Business account, so this feature isn't available.",
              '비즈니스 계정에서는 이 기능을 사용할 수 없어요.',
            )}
          </p>
        </div>
        <BaseButton
          type='primary'
          size='l'
          hideIcon
          onClick={() => navigate('/jobs')}
        >
          {t('Go to Job Board', 'Job Board로 이동')}
        </BaseButton>
      </div>
    </div>
  );
};

export default PersonalOnlyBlocked;
